"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showKebabMenu = exports.showMoveFunction = void 0;
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const showMoveFunction = ({ report }) => {
    const userId = localStorage.getItem('user_id');
    return (userId === report.userId?.toString() &&
        localStorage.getItem('user_is_editor') === 'true' &&
        report.elementType === reportElementTypes_1.ReportElementTypes.Dashboard);
};
exports.showMoveFunction = showMoveFunction;
const showKebabMenu = ({ report }) => {
    const userId = localStorage.getItem('user_id');
    const isVisible = (userId === report.userId?.toString() &&
        localStorage.getItem('user_is_editor') === 'true' &&
        report.elementType === reportElementTypes_1.ReportElementTypes.Dashboard) ||
        report.elementType === reportElementTypes_1.ReportElementTypes.Folder;
    return isVisible;
};
exports.showKebabMenu = showKebabMenu;
